import React from 'react'
import PropTypes from 'prop-types'
import { Box, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { plural, usageSummary } from '../../service/coaching'

// Admin view of one run: model calls and tokens by category, and a clearly labelled estimate.
// Phones get stacked rows so the estimate itself is never hidden behind a horizontal scroll.
export default function RunCost ({ report }) {
  const summary = usageSummary(report)
  if (!summary) return null
  return <Paper component="section" variant="outlined" aria-label="Run usage and estimated cost" sx={{ p: 1.25 }}>
    <Typography variant="subtitle2" component="h2">Run usage and estimated cost (admin)</Typography>
    <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 600 }}>{summary.headline}</Typography>
    {summary.workerTime && <Typography variant="body2" color="text.secondary">{summary.workerTime}</Typography>}
    <Table size="small" aria-label="Model usage by category" sx={{ mt: 1, display: { xs: 'none', sm: 'table' } }}>
      <TableHead><TableRow>
        <TableCell>Category</TableCell><TableCell align="right">Calls</TableCell><TableCell align="right">Input tokens</TableCell>
        <TableCell align="right">Output tokens</TableCell><TableCell align="right">Model cost</TableCell>
      </TableRow></TableHead>
      <TableBody>
        {summary.rows.map(row => <TableRow key={row.name}>
          <TableCell>{row.label}{row.failed !== '0' ? ` (${row.failed} failed)` : ''}</TableCell>
          <TableCell align="right">{row.calls}</TableCell><TableCell align="right">{row.input}</TableCell>
          <TableCell align="right">{row.output}</TableCell><TableCell align="right">{row.cost}</TableCell>
        </TableRow>)}
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>Total</TableCell><TableCell align="right">{summary.totals.calls}</TableCell>
          <TableCell align="right">{summary.totals.input}</TableCell><TableCell align="right">{summary.totals.output}</TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>{summary.estimateText}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
    <Stack spacing={0.75} sx={{ mt: 1, display: { xs: 'flex', sm: 'none' } }} role="list" aria-label="Model usage by category (compact)">
      {summary.rows.map(row => <Box key={row.name} role="listitem" sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 0.75 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>{row.label}{row.failed !== '0' ? ` (${row.failed} failed)` : ''}</Typography>
        <Typography variant="body2">Model cost: {row.cost}</Typography>
        <Typography variant="body2" color="text.secondary">{plural(row.calls, 'call')} · {row.input} in / {row.output} out tokens</Typography>
      </Box>)}
      <Box role="listitem" sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 0.75 }}>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>Total: {summary.estimateText}</Typography>
        <Typography variant="body2" color="text.secondary">{plural(summary.totals.calls, 'call')} · {summary.totals.input} in / {summary.totals.output} out tokens</Typography>
      </Box>
    </Stack>
    <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1, fontSize: 13 }}>Model: {summary.model}. {summary.label}</Typography>
  </Paper>
}
RunCost.propTypes = { report: PropTypes.object }
